module.exports = __webpack_public_path__ + "static/media/bike.a709dd9d.svg";